import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import { formatChartDate, getBoundaryTimestamps } from '@/shared/utils/dateFormatters';
import { SORT_BY, STATUSES } from '~/sha256/Payouts';
import { useGetBalanceIdQuery, useGetTransactionsQuery } from '@/shared/api/Payouts';
import {selectDateRange, selectPollingInterval} from "@/processes/Settings";
import BarChart from '@/shared/ui/charts/BarChart';
import { useMinerAccount } from "@/processes/MinerAccounts";
import {useMemo} from "react";
import { useNavigation } from '@/processes/Router';

type PayoutsChartProps = {
  className?: string;
}

const PayoutsChart = (props: PayoutsChartProps) => {
  const { className } = props;
  const intl = useIntl();
  const pollingInterval = useSelector(selectPollingInterval);
  const dateRange = useSelector(selectDateRange);
  const { account, coin, miner } = useMinerAccount();
  const { isBTC } = useNavigation();

  const {
    data: balanceId,
  } = useGetBalanceIdQuery({ account, coin }, { skip: !(account || miner) })
  const {
    data: transactions = [],
    isSuccess: isTransactionsSuccess,
  } = useGetTransactionsQuery({
    coin,
    balanceId,
    account,
    miner,
    isSortingDESC: false,
    orderBy: SORT_BY.CREATED_AT,
  }, { pollingInterval, skip: isBTC ? !balanceId : !coin })

  const transactionsSuccess = useMemo(() => transactions.filter((transaction: any) => transaction.status === STATUSES.SUCCESS), [transactions])

  return (
    <>
      <BarChart
        isLoading={!isTransactionsSuccess}
        className="w-full h-[220px] mt-6"
        data={transactionsSuccess}
        emptyStateData={[{
          "createdAt": new Date(),
          "amount": 0,
        }]}
        XAxisProps={{
          dataKey: 'createdAt',
          formatter: (value) => formatChartDate({
            date:
            value,
            locale:
            intl.locale,
            dateRange,
            ...getBoundaryTimestamps(transactionsSuccess),
          }),
        }}
        YAxisProps={{
          dataKey: 'value',
          domain: [0, 'auto'],
          allowDecimals: true
        }}
        tooltipLabelFormatter={(value) => formatChartDate({ date: value, locale: intl.locale })}
        lines={[
          {
            name: intl.formatMessage({ id: 'payout' }),
            dataKey: "value",
            stroke: "#00CCAA",
          },
        ]}
      />
    </>
  );
}

export default PayoutsChart;
